require('expose-loader?eventBus!../src/utils/services/event_bus');

// We need to expose it globally because it's used out of webpacker bundlers
// If only used by webpacker, it could be imported directly and extracted via common chunks
